import React from 'react';
import { X } from 'lucide-react';

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  width?: number;
}

export default function Modal({ open, onClose, title, children, width = 480 }: Props) {
  if (!open) return null;
  return (
    <div
      style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',backdropFilter:'blur(3px)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000,padding:16}}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{
        background:'var(--bg-card)',border:'1px solid var(--border)',borderRadius:16,
        width:'100%',maxWidth:width,maxHeight:'92vh',display:'flex',flexDirection:'column',
        boxShadow:'var(--shadow-lg)',
      }}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'14px 20px',borderBottom:'1px solid var(--border)',flexShrink:0}}>
          <h2 style={{fontSize:15,fontWeight:600,color:'var(--text-primary)',margin:0}}>{title}</h2>
          <button
            onClick={onClose}
            style={{background:'none',border:'none',color:'var(--text-faint)',cursor:'pointer',padding:6,borderRadius:7,display:'flex',alignItems:'center',transition:'background 0.15s'}}
            onMouseEnter={e => (e.currentTarget.style.background='var(--bg-hover)')}
            onMouseLeave={e => (e.currentTarget.style.background='none')}>
            <X size={17} />
          </button>
        </div>
        <div style={{padding:20,overflowY:'auto',flex:1}}>{children}</div>
      </div>
    </div>
  );
}
